import { allyTmEvent } from '../../utils';

const useAllyTm = () => {
  return {
    allyTmEvent,
  };
};

export default useAllyTm;
